var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 7C4 6.80109 4.07902 6.61032 4.21967 6.46967C4.36032 6.32902 4.55109 6.25 4.75 6.25H19.75C19.9489 6.25 20.1397 6.32902 20.2803 6.46967C20.421 6.61032 20.5 6.80109 20.5 7C20.5 7.19891 20.421 7.38968 20.2803 7.53033C20.1397 7.67098 19.9489 7.75 19.75 7.75H4.75C4.55109 7.75 4.36032 7.67098 4.21967 7.53033C4.07902 7.38968 4 7.19891 4 7ZM6.5 12C6.5 11.8011 6.57902 11.6103 6.71967 11.4697C6.86032 11.329 7.05109 11.25 7.25 11.25H17.25C17.4489 11.25 17.6397 11.329 17.7803 11.4697C17.921 11.6103 18 11.8011 18 12C18 12.1989 17.921 12.3897 17.7803 12.5303C17.6397 12.671 17.4489 12.75 17.25 12.75H7.25C7.05109 12.75 6.86032 12.671 6.71967 12.5303C6.57902 12.3897 6.5 12.1989 6.5 12ZM9.5 17C9.5 16.8011 9.57902 16.6103 9.71967 16.4697C9.86032 16.329 10.0511 16.25 10.25 16.25H14.25C14.4489 16.25 14.6397 16.329 14.7803 16.4697C14.921 16.6103 15 16.8011 15 17C15 17.1989 14.921 17.3897 14.7803 17.5303C14.6397 17.671 14.4489 17.75 14.25 17.75H10.25C10.0511 17.75 9.86032 17.671 9.71967 17.5303C9.57902 17.3897 9.5 17.1989 9.5 17Z",
    fill: "#7575A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.cbb1551d7a6d1cbef377fe8ac04b254e.svg";
export { ForwardRef as ReactComponent };